import React from "react";
import { Search } from "lucide-react";
import CardContainer from "../Containers/CardContainer";
import Heading from "../Headers/Heading";
import FormattedResponse from "../Response/FormattedResponse";

const AnalysisCard = ({ onClick, analysisReport, className }) => {
  return (
    <CardContainer className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <Heading>পর্যবেক্ষণ</Heading>
        <button
          onClick={onClick}
          className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          <Search className="h-4 w-4" />
          <span>বিশ্লেষণ করুন</span>
        </button>
      </div>

      {analysisReport && (
        <FormattedResponse
          response={analysisReport}
          className={className}
        />
      )}
    </CardContainer>
  );
};

export default AnalysisCard;
